import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "./ui/table"
import { z } from "zod"
import { Button } from "./ui/button"
import { ConnectionCheckSchema } from "@/schemas/connection-check.schema"
import { ConnectionStatus } from "@/constants/status";
import { connectionCheckDomain } from "@/services/domains.service"
import { useCallback, useEffect, useState } from "react"
import { Kbd } from "./ui/kbd"

interface Props {
    domains: z.infer<typeof ConnectionCheckSchema>[]
}

export default function ConnectionCheckTable(props: Props) {
    const [currentDomains, setCurrentDomains] = useState<z.infer<typeof ConnectionCheckSchema>[]>([]);

    useEffect(() => {
        if(currentDomains.length === 0) {
            setCurrentDomains(props.domains);
        }
    }, [currentDomains, props.domains]);
    
    const setStatus = useCallback((status: number, index: number) => {
        const getDomain = {...props.domains[index]};
        getDomain.status = status;
        const allDomains = [...props.domains];
        props.domains[index] = getDomain;
        setCurrentDomains(allDomains);
    }, [props.domains]);

    const checkConnection = async (domain: z.infer<typeof ConnectionCheckSchema>, index: number) => {
        setStatus(ConnectionStatus.onGoing, index);
        const formdata = new FormData();
        formdata.append('id', domain.id);
        await connectionCheckDomain(formdata).then(result => {
            setStatus(result ? ConnectionStatus.completed : ConnectionStatus.failed, index);
        });
    }

    const checkAllConnections = async () => {
        currentDomains.forEach(async (element, index) => {
            setStatus(ConnectionStatus.onGoing, index);

            const formData = new FormData();
            formData.append('id', element.id);
            await connectionCheckDomain(formData).then(result => {
                setStatus(result ? ConnectionStatus.completed : ConnectionStatus.failed, index);
            });
        });
    }
    return (
        <div>
            <div>
                <Button onClick={() => checkAllConnections()}>Check all connections</Button>
            </div>
            <Table>
                <TableHeader>
                    <TableRow>
                        <TableHead>Name</TableHead>
                        <TableHead>Website/Folder</TableHead>
                        <TableHead>Package</TableHead>
                        <TableHead>Check</TableHead>
                        <TableHead>Status</TableHead>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {props.domains?.map((domain, index) => (
                        <TableRow key={domain.id}>
                            <TableCell>{domain.name}</TableCell>
                            <TableCell>{domain.website} <Kbd>/{domain.folder}</Kbd></TableCell>
                            <TableCell>{domain.package}</TableCell>
                            <TableCell><Button onClick={async () => await checkConnection(domain, index)}>Check Connection</Button></TableCell>
                            <TableCell>
                                {domain.status == ConnectionStatus.standBy && (
                                    <div></div>
                                )}
                                {domain.status == ConnectionStatus.onGoing && (
                                    <div className="bg-yellow-500 rounded-lg py-2 px-3 mb-3 text-center">Ongoing</div>
                                )}
                                {domain.status == ConnectionStatus.completed && (
                                    <div className="bg-green-500 rounded-lg py-2 px-3 mb-3 text-center">Connection Established</div>
                                )}
                                {domain.status == ConnectionStatus.failed && (
                                    <div className="bg-red-500 rounded-lg py-2 px-3 mb-3 text-center">Connection Failed</div>
                                )}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            {props.domains.length <= 0 && (
                <div className="flex flex-col w-full max-w-2xl  gap-y-4">
                    <p>No domains available</p>
                </div>
            )}
        </div>
    )
}